/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sales_Debtor_Record_PaymentInputs */

const vi_dashboard_sales_debtor_record_payment = /** @type {(inputs: Dashboard_Sales_Debtor_Record_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi thanh toán`)
};

/**

* @param {Dashboard_Sales_Debtor_Record_PaymentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_sales_debtor_record_payment = /** @type {((inputs?: Dashboard_Sales_Debtor_Record_PaymentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sales_Debtor_Record_PaymentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_sales_debtor_record_payment(inputs)
});